import { render, staticRenderFns } from "./LinkedinIcon.vue?vue&type=template&id=1154d576&scoped=true&"
import script from "./LinkedinIcon.vue?vue&type=script&setup=true&lang=ts&"
export * from "./LinkedinIcon.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1154d576",
  null
  
)

export default component.exports